import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { toast } from '@CommonComponents/toast'
import PropTypes from 'prop-types'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { canvasConnect as endpoints } from '@URLS'
import { DeepLinkSetup } from './DeepLinkSetup'
import { SelectedSectionsContainer } from './SelectionSectionsContainer'
import { ConfigBase } from '../base_comps/ConfigBase.js'

export const ConfigDeepLinksPageComp = () => {
  const [currentState, dispatch] = useStateValue()
  let params = window.location.pathname.split('/')
  let coursenum = params[3]
  let contextId = window.location.pathname.split('/')[4]
  useEffect(() => {
    async function getHomepageData(contextId, dispatch) {
      try {
        let resp = await client.get(endpoints.getInstructorData({ contextId }))
        dispatch({
          type: 'updateInstructorData',
          payload: { connectedCourses: resp.data.connectedCourses },
        })
      } catch (err) {
        console.log(err)
        toast.error(err.response.data.error)
      }
    }
    getHomepageData(contextId, dispatch)
  }, [])

  const checkFunc = (allSecIds, selSections) => {
    if (allSecIds.length == 0) {
      return false
    }
    return allSecIds.every(secId =>
      selSections.map(selSec => selSec).includes(secId)
    )
  }

  const selFunc = (allSecIds, selSections, dispatch) => {
    let allSelected = allSecIds.every(secId =>
      selSections.map(selSec => selSec).includes(secId)
    )
    if (allSelected) {
      dispatch({
        type: 'sectionSelection',
        selectedSections: [],
      })
    } else {
      dispatch({
        type: 'sectionSelection',
        selectedSections: currentState.allSecIds,
      })
    }
  }

  const expandFunc = (allChapIds, expSects) => {
    let allExpanded = allChapIds.every(chapId =>
      expSects.map(expAsmt => expAsmt).includes(chapId)
    )
    let payload
    let actionType = 'expandChapters'
    if (allExpanded) {
      return
    } else {
      payload = allChapIds
    }

    dispatch({
      type: actionType,
      payload: payload,
    })
  }

  return (
    <ConfigBase
      courseTitle={
        currentState.connectedCourses.length > 0 &&
        coursenum !== '-' &&
        currentState.connectedCourses.filter(
          course => coursenum === course.coursenum
        )[0].courseTitle
      }
      pageTitle="Reading"
      leftSide={DeepLinkSetup}
      rightSide={SelectedSectionsContainer}
      allItems={currentState.allChapIds}
      itemsPosted={currentState.linksPosted}
      itemsPosting={currentState.linksPosting}
      checkFunc={checkFunc}
      funcParams={[currentState.allSecIds, currentState.selectedSections]}
      dispatch={dispatch}
      selFunc={selFunc}
      expandFunc={expandFunc}
      expandFuncParams={[currentState.allChapIds, currentState.expandedChaps]}
      expandFuncType={'expandChapters'}
    />
  )
}

ConfigDeepLinksPageComp.propTypes = {
  history: PropTypes.object,
}

export const ConfigDeepLinksPage = withRouter(ConfigDeepLinksPageComp)

export const inCanvas = (secId, canvasSects) => {
  for (let i = 0; i < canvasSects.length; i++) {
    if (canvasSects[i][0] === secId) {
      return [true, canvasSects[i][1]]
    }
  }
  return [false, []]
}
